export const SKYTG24_LOCALHOST_MENU = {
  data: {
    secondary: [
      {
        anchorText: 'Cronaca',
        anchorHref: 'https://tg24.sky.it/cronaca',
        anchorRel: 'follow',
        anchorZoneId: 'skytg24-menu-main_cronaca_null',
        anchorClassNames: 'c-cta c-cta--skyheadline',
        anchorTarget: '_self',
      },
      {
        anchorText: 'Economia',
        anchorHref: 'https://tg24.sky.it/economia',
        anchorRel: 'follow',
        anchorZoneId: 'skytg24-menu-main_economia_null',
        anchorClassNames: 'c-cta c-cta--skyheadline',
        anchorTarget: '_self',
      },
      {
        anchorText: 'Mondo',
        anchorHref: 'https://tg24.sky.it/mondo',
        anchorRel: 'follow',
        anchorZoneId: 'skytg24-menu-main_mondo_null',
        anchorClassNames: 'c-cta c-cta--skyheadline',
        anchorTarget: '_self',
      },
      {
        anchorText: 'Politica',
        anchorHref: 'https://tg24.sky.it/politica',
        anchorRel: 'follow',
        anchorZoneId: 'skytg24-menu-main_politica_null',
        anchorClassNames: 'c-cta c-cta--skyheadline',
        anchorTarget: '_self',
      },
      {
        anchorText: 'Spettacolo',
        anchorHref: 'https://tg24.sky.it/spettacolo',
        anchorRel: 'follow',
        anchorZoneId: 'skytg24-menu-main_spettacolo_null',
        anchorClassNames: 'c-cta c-cta--skyheadline',
        anchorTarget: '_self',
      },
      {
        anchorText: 'Diretta TG24',
        anchorHref: 'https://tg24.sky.it/video',
        anchorRel: 'follow',
        anchorZoneId: 'skytg24-menu-main_diretta-tg24_null',
        anchorClassNames: 'c-cta c-cta--skyheadline',
        anchorTarget: '_self',
      },
    ],
    sections: [
      {
        title: 'Tutti i temi',
        listClassNames: 'c-local-nav__list c-local-nav__list--grid',
        items: [
          {
            anchorText: 'Lifestyle',
            anchorHref: 'https://tg24.sky.it/lifestyle',
            anchorRel: 'follow',
            anchorZoneId: 'skytg24-menu-tutti-i-temi_lifestyle_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Sport',
            anchorHref: 'https://tg24.sky.it/sport',
            anchorRel: 'follow',
            anchorZoneId: 'skytg24-menu-tutti-i-temi_sport_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Salute e benessere',
            anchorHref: 'https://tg24.sky.it/salute-e-benessere',
            anchorRel: 'follow',
            anchorZoneId: 'skytg24-menu-tutti-i-temi_salute-e-benessere_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Motori',
            anchorHref: 'https://tg24.sky.it/motori',
            anchorRel: 'follow',
            anchorZoneId: 'skytg24-menu-tutti-i-temi_motori_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Tecnologia',
            anchorHref: 'https://tg24.sky.it/tecnologia',
            anchorRel: 'follow',
            anchorZoneId: 'skytg24-menu-tutti-i-temi_tecnologia_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Scienze',
            anchorHref: 'https://tg24.sky.it/scienze',
            anchorRel: 'follow',
            anchorZoneId: 'skytg24-menu-tutti-i-temi_scienze_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Ambiente',
            anchorHref: 'https://tg24.sky.it/ambiente',
            anchorRel: 'follow',
            anchorZoneId: 'skytg24-menu-tutti-i-temi_ambiente_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'News dalle citta',
            anchorHref: 'https://tg24.sky.it/edizioni-locali',
            anchorRel: 'follow',
            anchorZoneId: 'skytg24-menu-tutti-i-temi_news-dalle-città_null',
            anchorTarget: '_self',
          },
        ],
      },
      {
        title: 'Tutti i giorni',
        listClassNames: 'c-local-nav__list c-local-nav__list--grid',
        items: [
          {
            anchorText: 'Oroscopo',
            anchorHref: 'https://tg24.sky.it/lifestyle/oroscopo',
            anchorRel: 'follow',
            anchorZoneId: 'skytg24-menu-tutti-i-giorni_oroscopo_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Estrazioni Lotto e Superenalotto',
            anchorHref: 'https://tg24.sky.it/lifestyle/giochi',
            anchorRel: 'follow',
            anchorZoneId: 'skytg24-menu-tutti-i-giorni_estrazioni-lotto-e-superenalotto_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Meteo',
            anchorHref: 'https://tg24.sky.it/meteo',
            anchorRel: 'follow',
            anchorZoneId: 'skytg24-menu-tutti-i-giorni_meteo_null',
            anchorTarget: '_self',
          },
        ],
      },
      {
        title: 'Il mondo di SKY TG24',
        listClassNames: 'c-local-nav__list c-local-nav__list--grid',
        items: [
          {
            anchorText: 'Podcast',
            anchorHref: 'https://tg24.sky.it/podcast',
            anchorRel: 'follow',
            anchorZoneId: 'skytg24-menu-il-mondo-di-sky-tg24_podcast_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Video',
            anchorHref: 'https://tg24.sky.it/video',
            anchorRel: 'follow',
            anchorZoneId: 'skytg24-menu-il-mondo-di-sky-tg24_video_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Voice',
            anchorHref: 'https://video.sky.it/voice',
            anchorRel: 'follow',
            anchorZoneIdQp: 'skytg24-menu-il-mondo-di-sky-tg24_voice_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Sky TG24 Insider',
            anchorHref: 'https://tg24.sky.it/insider',
            anchorRel: 'follow',
            anchorZoneId: 'skytg24-menu-il-mondo-di-sky-tg24_sky-tg24-insider_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'La nostra app',
            anchorHref: 'https://tg24.sky.it/stories/tecnologia/nuova-app-sky-tg24-download/index.html',
            anchorRel: 'follow',
            anchorZoneId: 'skytg24-menu-il-mondo-di-sky-tg24_la-nostra-app_null',
            anchorTarget: '_self',
          },
        ],
      },
      {
        title: 'Potrebbero interessarti',
        listClassNames: 'c-local-nav__list c-local-nav__list--grid',
        items: [
          {
            anchorText: 'Sky Sport',
            anchorHref: 'https://sport.sky.it/',
            anchorRel: 'follow',
            anchorZoneIdQp: 'skytg24-menu-potrebbe-interessarti_sky-sport_null',
            listItemClassNames: 'c-local-nav__list-item c-local-nav__list-item--external-link',
            anchorTarget: '_self',
            image: {
              urlImage:
                'https://static.sky.it/editorialimages/a03891b78d213c122fae645822f4acd889534a5a/skytg24/configurations/menu-items/hamburger/LogoSkySport.png',
            },
          },
          {
            anchorText: 'XFactor',
            anchorHref: 'https://xfactor.sky.it/',
            anchorRel: 'follow',
            anchorZoneIdQp: 'skytg24-menu-potrebbe-interessarti_x-factor_null',
            listItemClassNames: 'c-local-nav__list-item c-local-nav__list-item--external-link',
            anchorTarget: '_self',
            image: {
              urlImage:
                'https://static.sky.it/editorialimages/352f3d02e59e9a998299289788743afd9d05342d/skytg24/configurations/menu-items/hamburger/x_factor.png',
            },
          },
          {
            anchorText: 'MasterChef',
            anchorHref: 'https://masterchef.sky.it/',
            anchorRel: 'follow',
            anchorZoneIdQp: 'skytg24-menu-potrebbe-interessarti_masterchef_null',
            listItemClassNames: 'c-local-nav__list-item c-local-nav__list-item--external-link',
            anchorTarget: '_self',
            image: {
              urlImage:
                'https://static.sky.it/editorialimages/556897a45ce3a2782e7cceb296b20e7b425bc149/skytg24/configurations/menu-items/hamburger/masterchef.png',
            },
          },
          {
            anchorText: 'Pechino Express',
            anchorHref: 'https://pechinoexpress.sky.it/',
            anchorRel: 'follow',
            anchorZoneIdQp: 'skytg24-menu-potrebbe-interessarti_pechino-express_null',
            listItemClassNames: 'c-local-nav__list-item c-local-nav__list-item--external-link',
            anchorTarget: '_self',
            image: {
              urlImage:
                'https://static.sky.it/editorialimages/fc17447ac6082b8ed033d17cc35932c671fba577/skytg24/configurations/menu-items/hamburger/pechino_epress.png',
            },
          },
        ],
      },
      {
        title: 'Altro',
        listClassNames: 'c-local-nav__list c-local-nav__list--grid',
        items: [
          {
            anchorText: 'Archivio',
            anchorHref: 'https://tg24.sky.it/archivio',
            anchorRel: 'follow',
            anchorZoneId: 'skytg24-menu-altro_archivio_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Mappa del sito',
            anchorHref: 'https://tg24.sky.it/site-map',
            anchorRel: 'follow',
            anchorZoneId: 'skytg24-menu-altro_mappa-del-sito_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Chi siamo',
            anchorHref: 'https://tg24.sky.it/editore/redazione',
            anchorRel: 'follow',
            anchorZoneId: 'skytg24-menu-altro_chi-siamo_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Notifiche',
            anchorHref: '#',
            anchorRel: 'follow',
            anchorZoneIdQp: 'skytg24-menu-altro_notifiche_null',
            anchorClassNames: 'c-local-nav__featured--highlighted c-local-nav__featured--with-icon',
            listItemClassNames: 'c-local-nav__list-item is-hidden',
            anchorTarget: '_self',
            anchorId: 'WPNEditLabel',
            icon: {
              classNames: 'icon icon--mix icon--bell icon--c-light',
              svg: 'PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iI2ZmZiIgY2xhc3M9Imljb25fX3N2ZyBpY29uX19zdmctLWJlbGwiIHdpZHRoPSI4MCIgaGVpZ2h0PSI4MCI+DQogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMiAyMmMxLjEgMCAyLS45IDItMmgtNGMwIDEuMS45IDIgMiAyem02LTZ2LTVjMC0zLjA3LTEuNjMtNS42NC00LjUtNi4zMlY0YzAtLjgzLS42Ny0xLjUtMS41LTEuNXMtMS41LjY3LTEuNSAxLjV2LjY4QzcuNjQgNS4zNiA2IDcuOTIgNiAxMXY1bC0yIDJ2MWgxNnYtMWwtMi0yem0tMiAxSDh2LTZjMC0yLjQ4IDEuNTEtNC41IDQtNC41czQgMi4wMiA0IDQuNXY2eiI+DQogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDwvcGF0aD4NCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8L3N2Zz4=',
            },
          },
        ],
      },
      {
        title: 'Seguici',
        listClassNames: 'c-local-nav__list c-local-nav__list--flex',
        items: [
          {
            anchorText: '',
            anchorHref: 'https://facebook.com/SkyTG24',
            anchorRel: 'external',
            anchorZoneIdQp: '',
            anchorTarget: '_blank',
            icon: {
              classNames: 'icon icon--social icon--facebook icon--small ',
              svg: 'PHN2ZyB2aWV3Qm94PSIwIDAgMTggMTgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9Imljb25fX3N2ZyBpY29uX19zdmctLWZhY2Vib29rIiBmaWxsPSJjdXJyZW50Q29sb3IiIHdpZHRoPSI4MCIgaGVpZ2h0PSI4MCIgYXJpYS1sYWJlbD0iRmFjZWJvb2siIHJvbGU9ImltZyI+PHBhdGggZD0iTTE4IDlDMTggNC4wMjg0IDEzLjk3MTYgMCA5IDBDNC4wMjg0IDAgMCA0LjAyODQgMCA5QzAgMTMuMjE5MiAyLjkwNTIgMTYuNzYxNiA2LjgyNTYgMTcuNzMzNlYxMS43NTA0SDQuOTY4VjlINi44MjU2VjcuODE1NkM2LjgyNTYgNC43NTIgOC4yMTE2IDMuMzMzNiAxMS4yMTc2IDMuMzMzNkMxMS43ODY0IDMuMzMzNiAxMi43NzI4IDMuNDQ1MiAxMy4xNzI0IDMuNTU2OFY2LjA0OEMxMi45NiA2LjAyNjQgMTIuNTkyOCA2LjAxNTYgMTIuMTMyIDYuMDE1NkMxMC42NTYgNi4wMTU2IDEwLjA4NzIgNi41NzM2IDEwLjA4NzIgOC4wMjhWOUgxMy4wMjg0TDEyLjUyNDQgMTEuNzUwNEgxMC4wOTA4VjE3LjkzNTJDMTQuNTQ3NiAxNy4zOTUyIDE4IDEzLjYwMDggMTggOVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==',
            },
          },
          {
            anchorText: '',
            anchorHref: 'https://x.com/SkyTG24',
            anchorRel: 'external',
            anchorZoneIdQp: '',
            anchorTarget: '_blank',
            icon: {
              classNames: 'icon icon--social icon--twitter icon--small ',
              svg: 'PHN2ZyB2aWV3Qm94PSIwIDAgMTggMTgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9Imljb25fX3N2ZyBpY29uX19zdmctLXR3aXR0ZXIiIGZpbGw9ImN1cnJlbnRDb2xvciIgd2lkdGg9IjgwIiBoZWlnaHQ9IjgwIiBhcmlhLWxhYmVsPSJUd2l0dGVyIiByb2xlPSJpbWciPjxwYXRoIGQ9Ik0xMC43MTI0IDcuNjIxNzdMMTcuNDEzMyAwSDE1LjgyNTRMMTAuMDA3MSA2LjYxNzg4TDUuMzU5OTIgMEgwTDcuMDI3MzggMTAuMDA3NEwwIDE4SDEuNTg3OTlMNy43MzIzNyAxMS4wMTEzTDEyLjY0MDEgMThIMThMMTAuNzEyMSA3LjYyMTc3SDEwLjcxMjRaTTguNTM3NDcgMTAuMDk1Nkw3LjgyNTQ2IDkuMDk5MDZMMi4xNjAxNyAxLjE2OTcxSDQuNTk5MjJMOS4xNzExOCA3LjU2ODk1TDkuODgzMiA4LjU2NTQ2TDE1LjgyNjIgMTYuODgzNUgxMy4zODcxTDguNTM3NDcgMTAuMDk2VjEwLjA5NTZaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=',
            },
          },
          {
            anchorText: '',
            anchorHref: 'https://flipboard.com/@SkyTG24',
            anchorRel: 'external',
            anchorZoneIdQp: '',
            anchorTarget: '_blank',
            icon: {
              classNames: 'icon icon--social icon--flipboard icon--small ',
              svg: 'PHN2ZyB2aWV3Qm94PSIwIDAgMTggMTgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9Imljb25fX3N2ZyBpY29uX19zdmctLWZsaXBib2FyZCIgZmlsbD0iY3VycmVudENvbG9yIiB3aWR0aD0iODAiIGhlaWdodD0iODAiIGFyaWEtbGFiZWw9IkZsaXBib2FyZCIgcm9sZT0iaW1nIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTAgMEgxOFY2LjM1Mjk0SDExLjY0NzFWMTIuNzA1OUg2LjM1Mjk0VjE4SDBWMTIuNzA1OVYxMS42NDcxVjYuMzUyOTRWMFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==',
            },
          },
          {
            anchorText: '',
            anchorHref: 'https://www.instagram.com/skytg24/#',
            anchorRel: 'external',
            anchorZoneIdQp: '',
            anchorTarget: '_blank',
            icon: {
              classNames: 'icon icon--social icon--instagram icon--small ',
              svg: 'PHN2ZyB2aWV3Qm94PSIwIDAgMTggMTgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9Imljb25fX3N2ZyBpY29uX19zdmctLWluc3RhZ3JhbSIgZmlsbD0iY3VycmVudENvbG9yIiB3aWR0aD0iODAiIGhlaWdodD0iODAiIGFyaWEtbGFiZWw9Ikluc3RhZ3JhbSIgcm9sZT0iaW1nIj48cGF0aCBkPSJNMTIuNDkwMyAxOEg1LjUwOTczQzIuNDc0NzEgMTggMCAxNS41MjUzIDAgMTIuNDkwM1Y1LjUwOTczQzAgMi40NzQ3MSAyLjQ3NDcxIDAgNS41MDk3MyAwSDEyLjQ5MDNDMTUuNTI1MyAwIDE4IDIuNDc0NzEgMTggNS41MDk3M1YxMi40OTAzQzE4IDE1LjUyNTMgMTUuNTI1MyAxOCAxMi40OTAzIDE4Wk01LjUzMzA4IDEuMzU0MDlDMy4yNDUxNCAxLjM1NDA5IDEuMzc3NDMgMy4yMjE3OSAxLjM3NzQzIDUuNTA5NzNWMTIuNDkwM0MxLjM3NzQzIDE0Ljc3ODIgMy4yNDUxNCAxNi42NDU5IDUuNTMzMDggMTYuNjQ1OUgxMi40OTAzQzE0Ljc3ODIgMTYuNjQ1OSAxNi42NDU5IDE0Ljc3ODIgMTYuNjQ1OSAxMi40OTAzVjUuNTA5NzNDMTYuNjQ1OSAzLjIyMTc5IDE0Ljc3ODIgMS4zNTQwOSAxMi40OTAzIDEuMzU0MDlINS41MzMwOFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjxwYXRoIGQ9Ik05LjAxMTc2IDEzLjU0MDhDNi41MTM3IDEzLjU0MDggNC40NTkyMyAxMS41MDk3IDQuNDU5MjMgOC45ODgyNkM0LjQ1OTIzIDYuNDkwMiA2LjQ5MDM2IDQuNDM1NzMgOS4wMTE3NiA0LjQzNTczQzExLjUzMzIgNC40MzU3MyAxMy41NjQzIDYuNDY2ODYgMTMuNTY0MyA4Ljk4ODI2QzEzLjU2NDMgMTEuNTA5NyAxMS41MDk4IDEzLjU0MDggOS4wMTE3NiAxMy41NDA4Wk05LjAxMTc2IDUuODM2NTFDNy4yNjA3OCA1LjgzNjUxIDUuODM2NjYgNy4yNjA2MyA1LjgzNjY2IDkuMDExNjFDNS44MzY2NiAxMC43NjI2IDcuMjYwNzggMTIuMTg2NyA5LjAxMTc2IDEyLjE4NjdDMTAuNzYyNyAxMi4xODY3IDEyLjE4NjkgMTAuNzYyNiAxMi4xODY5IDkuMDExNjFDMTIuMTg2OSA3LjI2MDYzIDEwLjc2MjcgNS44MzY1MSA5LjAxMTc2IDUuODM2NTFaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48cGF0aCBkPSJNMTUuMjQ1MiAzLjk2ODg2QzE1LjI0NTIgNC42MjI1NiAxNC43MDgzIDUuMTU5NTIgMTQuMDU0NiA1LjE1OTUyQzEzLjQwMDkgNS4xNTk1MiAxMi44NjM5IDQuNjIyNTYgMTIuODYzOSAzLjk2ODg2QzEyLjg2MzkgMy4zMTUxNiAxMy40MDA5IDIuNzc4MiAxNC4wNTQ2IDIuNzc4MkMxNC43MDgzIDIuNzc4MiAxNS4yNDUyIDMuMjkxODIgMTUuMjQ1MiAzLjk2ODg2WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+',
            },
          },
          {
            anchorText: '',
            anchorHref: 'https://www.tiktok.com/@skytg24',
            anchorRel: 'external',
            anchorZoneIdQp: '',
            anchorTarget: '_blank',
            icon: {
              classNames: 'icon icon--social icon--tiktok icon--small ',
              svg: 'PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMTgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9Imljb25fX3N2ZyBpY29uX19zdmctLXRpa3RvayIgZmlsbD0iY3VycmVudENvbG9yIiB3aWR0aD0iODAiIGhlaWdodD0iODAiIGFyaWEtbGFiZWw9IlRpa1RvayIgcm9sZT0iaW1nIj48cGF0aCBkPSJNMTYgNC4yMDkzNUMxMy42MzI3IDQuMjA5MzUgMTEuNzE0MyAyLjMyNTE3IDExLjcxNDMgMEg4LjQ4OThWMTIuMjQ3MkM4LjQ4OTggMTMuNjcwNCA3LjMwNjEzIDE0LjgzMyA1Ljg1NzE1IDE0LjgzM0M0LjQwODE3IDE0LjgzMyAzLjIyNDQ5IDEzLjY3MDQgMy4yMjQ0OSAxMi4yNDcyQzMuMjI0NDkgMTAuODI0MSA0LjQwODE3IDkuNjYxNDcgNS44NTcxNSA5LjY2MTQ3QzYuMTIyNDUgOS42NjE0NyA2LjQyODU3IDkuNzAxNTYgNi42NzM0NyA5Ljc4MTc0VjYuNTU0NTZDNi40MDgxNyA2LjUxNDQ3IDYuMTIyNDUgNi40OTQ0MyA1Ljg1NzE1IDYuNDk0NDNDMi42MzI2NiA2LjQ5NDQzIDAgOS4wNjAxNCAwIDEyLjI0NzJDMCAxNS40MTQzIDIuNjEyMjUgMTggNS44NTcxNSAxOEM5LjA4MTY0IDE4IDExLjcxNDMgMTUuNDM0MyAxMS43MTQzIDEyLjI0NzJWNS43NzI4M0MxMi44Nzc2IDYuNzE0OTIgMTQuMzg3OCA3LjI3NjE3IDE2IDcuMjc2MTdWNC4yMDkzNVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==',
            },
          },
        ],
      },
    ],
  },
};

export const SKYSPORT_LOCALHOST_MENU = {
  data: {
    secondary: [
      {
        anchorText: 'Calcio',
        anchorHref: 'https://sport.sky.it/calcio',
        anchorRel: 'follow',
        anchorZoneId: 'skysport-menu-main_calcio_null',
        anchorClassNames: 'c-cta c-cta--skyheadline',
        anchorTarget: '_self',
      },
      {
        anchorText: 'Calciomercato',
        anchorHref: 'https://sport.sky.it/calciomercato',
        anchorRel: 'follow',
        anchorZoneId: 'skysport-menu-main_calciomercato_null',
        anchorClassNames: 'c-cta c-cta--skyheadline',
        anchorTarget: '_self',
      },
      {
        anchorText: 'Tennis',
        anchorHref: 'https://sport.sky.it/tennis',
        anchorRel: 'follow',
        anchorZoneId: 'skysport-menu-main_tennis_null',
        anchorClassNames: 'c-cta c-cta--skyheadline',
        anchorTarget: '_self',
      },
      {
        anchorText: 'Formula 1',
        anchorHref: 'https://sport.sky.it/formula-1',
        anchorRel: 'follow',
        anchorZoneId: 'skysport-menu-main_formula-1_null',
        anchorClassNames: 'c-cta c-cta--skyheadline',
        anchorTarget: '_self',
      },
      {
        anchorText: 'MotoGp',
        anchorHref: 'https://sport.sky.it/motogp',
        anchorRel: 'follow',
        anchorZoneId: 'skysport-menu-main_motogp_null',
        anchorClassNames: 'c-cta c-cta--skyheadline',
        anchorTarget: '_self',
      },
      {
        anchorText: 'NBA',
        anchorHref: 'https://sport.sky.it/nba',
        anchorRel: 'follow',
        anchorZoneId: 'skysport-menu-main_nba_null',
        anchorClassNames: 'c-cta c-cta--skyheadline',
        anchorTarget: '_self',
      },
    ],
    sections: [
      {
        title: 'Highlights',
        listClassNames: 'c-local-nav__list c-local-nav__list--grid',
        items: [
          {
            anchorText: 'Champions League',
            anchorHref: 'https://sport.sky.it/video/highlights#calcio_champions-league',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-highlights_champions-league_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Serie A',
            anchorHref: 'https://sport.sky.it/video/highlights#calcio_serie-a',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-highlights_serie-a_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Premier League',
            anchorHref: 'https://sport.sky.it/video/highlights#calcio_premier-league',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-highlights_premier-league_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Tennis',
            anchorHref: 'https://sport.sky.it/video/highlights#tennis',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-highlights_tennis_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Formula 1',
            anchorHref: 'https://sport.sky.it/video/highlights#formula1',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-highlights_formula-1_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'MotoGP',
            anchorHref: 'https://sport.sky.it/video/highlights#motogp',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-highlights_motogp_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'NBA',
            anchorHref: 'https://sport.sky.it/video/highlights#nba',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-highlights_nba_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Tutti gli highlights',
            anchorHref: 'https://sport.sky.it/video/highlights',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-highlights_tutti-gli-hl_null',
            anchorTarget: '_self',
          },
        ],
      },
      {
        title: 'Champions League',
        listClassNames: 'c-local-nav__list c-local-nav__list--grid',
        items: [
          {
            anchorText: 'News',
            anchorHref: 'https://sport.sky.it/calcio/champions-league',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-champions-league_news_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Calendario e risultati',
            anchorHref: 'https://sport.sky.it/calcio/champions-league/calendario-risultati',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-champions-league_calendario-risultati_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Classifica',
            anchorHref: 'https://sport.sky.it/calcio/champions-league/classifica',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-champions-league_classifica_null',
            anchorTarget: '_self',
          },
        ],
      },
      {
        title: 'Calcio - Serie A',
        listClassNames: 'c-local-nav__list c-local-nav__list--grid',
        items: [
          {
            anchorText: 'News',
            anchorHref: 'https://sport.sky.it/calcio/serie-a',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-calcio-serie-a_news_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Calendario e risultati',
            anchorHref: 'https://sport.sky.it/calcio/serie-a/calendario-risultati',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-calcio-serie-a_calendario-risultati_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Classifica',
            anchorHref: 'https://sport.sky.it/calcio/serie-a/classifica',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-calcio-serie-a_classifica_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Pagelle',
            anchorHref: 'https://sport.sky.it/calcio/serie-a/pagelle',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-calcio-serie-a_pagelle_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Probabili formazioni',
            anchorHref: 'https://sport.sky.it/calcio/serie-a/probabili-formazioni',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-calcio-serie-a_probabili-formazioni_null',
            anchorTarget: '_self',
          },
        ],
      },
      {
        title: 'Calcio - Nazionali',
        listClassNames: 'c-local-nav__list c-local-nav__list--grid',
        items: [
          {
            anchorText: 'Mondiali',
            anchorHref: 'https://sport.sky.it/calcio/mondiali',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-calcio-nazionali_mondiali_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Europei',
            anchorHref: 'https://sport.sky.it/calcio/europei',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-calcio-nazionali_europei_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Nations League',
            anchorHref: 'https://sport.sky.it/calcio/nations-league',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-calcio-nazionali_nations-league_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Copa America',
            anchorHref: 'https://sport.sky.it/calcio/coppa-america',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-calcio-nazionali_copa-america_null',
            anchorTarget: '_self',
          },
          {
            anchorText: "Coppa d'Africa",
            anchorHref: 'https://sport.sky.it/calcio/coppa-d-africa',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-calcio-nazionali_coppa-africa_null',
            anchorTarget: '_self',
          },
        ],
      },
      {
        title: 'Calcio - Altre serie',
        listClassNames: 'c-local-nav__list c-local-nav__list--grid',
        items: [
          {
            anchorText: 'Serie B',
            anchorHref: 'https://sport.sky.it/calcio/serie-b',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-calcio-altre-serie_serie-b_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Serie C',
            anchorHref: 'https://sport.sky.it/calcio/serie-c',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-calcio-altre-serie_serie-c_null',
            anchorTarget: '_self',
          },
        ],
      },
      {
        title: 'Calcio - Coppe europee',
        listClassNames: 'c-local-nav__list c-local-nav__list--grid',
        items: [
          {
            anchorText: 'Champions League',
            anchorHref: 'https://sport.sky.it/calcio/champions-league',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-calcio-coppe-europee_champions-league_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Europa League',
            anchorHref: 'https://sport.sky.it/calcio/europa-league',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-calcio-coppe-europee_europa-league_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Conference League',
            anchorHref: 'https://sport.sky.it/calcio/conference-league',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-calcio-coppe-europee_conference-league_null',
            anchorTarget: '_self',
          },
        ],
      },
      {
        title: 'Calcio - Estero',
        listClassNames: 'c-local-nav__list c-local-nav__list--grid',
        items: [
          {
            anchorText: 'Premier League',
            anchorHref: 'https://sport.sky.it/calcio/premier-league',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-calcio-estero_premier-league_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Bundesliga',
            anchorHref: 'https://sport.sky.it/calcio/bundesliga',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-calcio-estero_bundesliga_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Liga',
            anchorHref: 'https://sport.sky.it/calcio/liga',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-calcio-estero_liga_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Ligue 1',
            anchorHref: 'https://sport.sky.it/calcio/ligue-1',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-calcio-estero_ligue-1_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Eredivisie',
            anchorHref: 'https://sport.sky.it/calcio/eredivisie',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-calcio-estero_eredivisie_null',
            anchorTarget: '_self',
          },
        ],
      },
      {
        title: 'Motori',
        listClassNames: 'c-local-nav__list c-local-nav__list--grid',
        items: [
          {
            anchorText: 'Formula 1',
            anchorHref: 'https://sport.sky.it/formula-1',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-motori_formula-1_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Moto GP',
            anchorHref: 'https://sport.sky.it/motogp',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-motori_motogp_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Superbike',
            anchorHref: 'https://sport.sky.it/motori/sbk',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-motori_superbike_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Rally',
            anchorHref: 'https://sport.sky.it/motori/rally',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-motori_rally_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'News',
            anchorHref: 'https://sport.sky.it/motori',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-motori_null',
            anchorTarget: '_self',
          },
        ],
      },
      {
        title: 'Tutti gli sport',
        listClassNames: 'c-local-nav__list c-local-nav__list--grid',
        items: [
          {
            anchorText: 'Ciclismo',
            anchorHref: 'https://sport.sky.it/ciclismo',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-tutti-gli-sport_ciclismo_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Basket',
            anchorHref: 'https://sport.sky.it/basket',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-tutti-gli-sport_basket_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Volley',
            anchorHref: 'https://sport.sky.it/volley',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-tutti-gli-sport_volley_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Rugby',
            anchorHref: 'https://sport.sky.it/rugby',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-tutti-gli-sport_rugby_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Sci',
            anchorHref: 'https://sport.sky.it/altri-sport/sci',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-tutti-gli-sport_sci_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Golf',
            anchorHref: 'https://sport.sky.it/altri-sport/golf',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-tutti-gli-sport_golf_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Atletica',
            anchorHref: 'https://sport.sky.it/altri-sport/atletica',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-tutti-gli-sport_atletica_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Vela',
            anchorHref: 'https://sport.sky.it/altri-sport/vela',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-tutti-gli-sport_vela_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Sport USA',
            anchorHref: 'https://sport.sky.it/sport-usa',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-tutti-gli-sport_sport-usa_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Scherma',
            anchorHref: 'https://sport.sky.it/altri-sport/scherma',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-tutti-gli-sport_scherma_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Boxe',
            anchorHref: 'https://sport.sky.it/altri-sport/boxe',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-tutti-gli-sport_boxe_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Olimpiadi',
            anchorHref: 'https://sport.sky.it/olimpiadi',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-tutti-gli-sport_olimpiadi_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Altri Sport',
            anchorHref: 'https://sport.sky.it/altri-sport',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-tutti-gli-sport_altri-sport_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Oltre lo Sport',
            anchorHref: 'https://sport.sky.it/altro',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-tutti-gli-sport_altro_null',
            anchorTarget: '_self',
          },
        ],
      },
      {
        title: 'Il mondo di Sky Sport',
        listClassNames: 'c-local-nav__list c-local-nav__list--grid',
        items: [
          {
            anchorText: 'SkyLights Room',
            anchorHref: 'https://sport.sky.it/video/highlights',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-mondo-sky_skylight-room_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Sky Sport Insider',
            anchorHref: 'https://sport.sky.it/insider',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-mondo-sky_insider_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Risultati Live',
            anchorHref: 'https://sport.sky.it/live',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-mondo-sky_risultati-live_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Superscudetto',
            anchorHref: 'https://superscudetto.sky.it/',
            anchorRel: 'follow',
            anchorZoneIdQp: 'skysport-menu-mondo-sky_superscudetto_null',
            anchorTarget: '_self',
          },
        ],
      },
      {
        title: 'Potrebbero interessarti',
        listClassNames: 'c-local-nav__list c-local-nav__list--grid',
        items: [
          {
            anchorText: 'Sky TG24',
            anchorHref: 'https://tg24.sky.it/',
            anchorRel: 'follow',
            anchorZoneIdQp: 'skysport-menu-potrebbe-interessarti_sky-tg24_null',
            listItemClassNames: 'c-local-nav__list-item c-local-nav__list-item--external-link',
            anchorTarget: '_self',
            image: {
              urlImage:
                'https://static.sky.it/editorialimages/bafcaa305112c5ae5b4427eb0cf98165ca503a01/skysport/configurations/menu-items/hamburger/LogoSkyTG24.png',
            },
          },
          {
            anchorText: 'X Factor',
            anchorHref: 'https://xfactor.sky.it/',
            anchorRel: 'follow',
            anchorZoneIdQp: 'skysport-menu-potrebbe-interessarti_x-factor_null',
            listItemClassNames: 'c-local-nav__list-item c-local-nav__list-item--external-link',
            anchorTarget: '_self',
            image: {
              urlImage:
                'https://static.sky.it/editorialimages/352f3d02e59e9a998299289788743afd9d05342d/skysport/configurations/menu-items/hamburger/x_factor.png',
            },
          },
          {
            anchorText: 'MasterChef',
            anchorHref: 'https://masterchef.sky.it/',
            anchorRel: 'follow',
            anchorZoneIdQp: 'skysport-menu-potrebbe-interessarti_masterchef_null',
            listItemClassNames: 'c-local-nav__list-item c-local-nav__list-item--external-link',
            anchorTarget: '_self',
            image: {
              urlImage:
                'https://static.sky.it/editorialimages/556897a45ce3a2782e7cceb296b20e7b425bc149/skysport/configurations/menu-items/hamburger/masterchef.png',
            },
          },
          {
            anchorText: 'Pechino Express',
            anchorHref: 'https://pechinoexpress.sky.it/',
            anchorRel: 'follow',
            anchorZoneIdQp: 'skysport-menu-potrebbe-interessarti_pechino-express_null',
            listItemClassNames: 'c-local-nav__list-item c-local-nav__list-item--external-link',
            anchorTarget: '_self',
            image: {
              urlImage:
                'https://static.sky.it/editorialimages/fc17447ac6082b8ed033d17cc35932c671fba577/skysport/configurations/menu-items/hamburger/pechino_epress.png',
            },
          },
        ],
      },
      {
        title: 'Altro',
        listClassNames: 'c-local-nav__list c-local-nav__list--grid',
        items: [
          {
            anchorText: 'Mappa del sito',
            anchorHref: 'https://sport.sky.it/site-map',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-altro_mappa-del-sito_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Chi Siamo',
            anchorHref: 'https://sport.sky.it/editore/redazione',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-altro_chi-siamo_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Archivio',
            anchorHref: 'https://sport.sky.it/archivio',
            anchorRel: 'follow',
            anchorZoneId: 'skysport-menu-altro_archivio_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Notifiche',
            anchorHref: '#',
            anchorRel: 'follow',
            anchorZoneIdQp: 'skysport-menu-altro_notifiche_null',
            anchorClassNames: 'c-local-nav__featured--highlighted c-local-nav__featured--with-icon',
            listItemClassNames: 'c-local-nav__list-item is-hidden',
            anchorTarget: '_self',
            anchorId: 'WPNEditLabel',
            icon: {
              classNames: 'icon icon--mix icon--bell icon--c-light',
              svg: 'PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iI2ZmZiIgY2xhc3M9Imljb25fX3N2ZyBpY29uX19zdmctLWJlbGwiIHdpZHRoPSI4MCIgaGVpZ2h0PSI4MCI+DQogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMiAyMmMxLjEgMCAyLS45IDItMmgtNGMwIDEuMS45IDIgMiAyem02LTZ2LTVjMC0zLjA3LTEuNjMtNS42NC00LjUtNi4zMlY0YzAtLjgzLS42Ny0xLjUtMS41LTEuNXMtMS41LjY3LTEuNSAxLjV2LjY4QzcuNjQgNS4zNiA2IDcuOTIgNiAxMXY1bC0yIDJ2MWgxNnYtMWwtMi0yem0tMiAxSDh2LTZjMC0yLjQ4IDEuNTEtNC41IDQtNC41czQgMi4wMiA0IDQuNXY2eiI+DQogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDwvcGF0aD4NCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8L3N2Zz4=',
            },
          },
          {
            anchorText: ' La mia home',
            anchorHref: 'https://www.sky.it/login?forward=https://sport.sky.it/',
            anchorRel: 'follow',
            anchorZoneIdQp: 'skysport-menu-main_la-mia-home_null',
            anchorTarget: '_self',
          },
          {
            anchorText: 'Shop',
            anchorHref: 'https://shop2.skysports.com/it/?_s=bm-fi-skysports-prtsite-web-%2F-header-it',
            anchorRel: 'follow',
            anchorZoneIdQp: 'skysport-menu-altro_shop_null',
            anchorTarget: '_blank',
          },
        ],
      },
      {
        title: 'Seguici',
        listClassNames: 'c-local-nav__list c-local-nav__list--flex',
        items: [
          {
            anchorText: '',
            anchorHref: 'https://www.facebook.com/SkySport',
            anchorRel: 'external',
            anchorZoneIdQp: '',
            anchorTarget: '_blank',
            icon: {
              classNames: 'icon icon--social icon--facebook icon--small icon--c-light',
              svg: 'PHN2ZyB2aWV3Qm94PSIwIDAgMTggMTgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9Imljb25fX3N2ZyBpY29uX19zdmctLWZhY2Vib29rIiBmaWxsPSJjdXJyZW50Q29sb3IiIHdpZHRoPSI4MCIgaGVpZ2h0PSI4MCIgYXJpYS1sYWJlbD0iRmFjZWJvb2siIHJvbGU9ImltZyI+PHBhdGggZD0iTTE4IDlDMTggNC4wMjg0IDEzLjk3MTYgMCA5IDBDNC4wMjg0IDAgMCA0LjAyODQgMCA5QzAgMTMuMjE5MiAyLjkwNTIgMTYuNzYxNiA2LjgyNTYgMTcuNzMzNlYxMS43NTA0SDQuOTY4VjlINi44MjU2VjcuODE1NkM2LjgyNTYgNC43NTIgOC4yMTE2IDMuMzMzNiAxMS4yMTc2IDMuMzMzNkMxMS43ODY0IDMuMzMzNiAxMi43NzI4IDMuNDQ1MiAxMy4xNzI0IDMuNTU2OFY2LjA0OEMxMi45NiA2LjAyNjQgMTIuNTkyOCA2LjAxNTYgMTIuMTMyIDYuMDE1NkMxMC42NTYgNi4wMTU2IDEwLjA4NzIgNi41NzM2IDEwLjA4NzIgOC4wMjhWOUgxMy4wMjg0TDEyLjUyNDQgMTEuNzUwNEgxMC4wOTA4VjE3LjkzNTJDMTQuNTQ3NiAxNy4zOTUyIDE4IDEzLjYwMDggMTggOVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==',
            },
          },
          {
            anchorText: '',
            anchorHref: 'https://x.com/SkySport',
            anchorRel: 'external',
            anchorZoneIdQp: '',
            anchorTarget: '_blank',
            icon: {
              classNames: 'icon icon--social icon--twitter icon--small icon--c-light',
              svg: 'PHN2ZyB2aWV3Qm94PSIwIDAgMTggMTgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9Imljb25fX3N2ZyBpY29uX19zdmctLXR3aXR0ZXIiIGZpbGw9ImN1cnJlbnRDb2xvciIgd2lkdGg9IjgwIiBoZWlnaHQ9IjgwIiBhcmlhLWxhYmVsPSJUd2l0dGVyIiByb2xlPSJpbWciPjxwYXRoIGQ9Ik0xMC43MTI0IDcuNjIxNzdMMTcuNDEzMyAwSDE1LjgyNTRMMTAuMDA3MSA2LjYxNzg4TDUuMzU5OTIgMEgwTDcuMDI3MzggMTAuMDA3NEwwIDE4SDEuNTg3OTlMNy43MzIzNyAxMS4wMTEzTDEyLjY0MDEgMThIMThMMTAuNzEyMSA3LjYyMTc3SDEwLjcxMjRaTTguNTM3NDcgMTAuMDk1Nkw3LjgyNTQ2IDkuMDk5MDZMMi4xNjAxNyAxLjE2OTcxSDQuNTk5MjJMOS4xNzExOCA3LjU2ODk1TDkuODgzMiA4LjU2NTQ2TDE1LjgyNjIgMTYuODgzNUgxMy4zODcxTDguNTM3NDcgMTAuMDk2VjEwLjA5NTZaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=',
            },
          },
          {
            anchorText: '',
            anchorHref: 'https://flipboard.com/@Sky_Sport',
            anchorRel: 'external',
            anchorZoneIdQp: '',
            anchorTarget: '_blank',
            icon: {
              classNames: 'icon icon--social icon--flipboard icon--small icon--c-light',
              svg: 'PHN2ZyB2aWV3Qm94PSIwIDAgMTggMTgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9Imljb25fX3N2ZyBpY29uX19zdmctLWZsaXBib2FyZCIgZmlsbD0iY3VycmVudENvbG9yIiB3aWR0aD0iODAiIGhlaWdodD0iODAiIGFyaWEtbGFiZWw9IkZsaXBib2FyZCIgcm9sZT0iaW1nIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTAgMEgxOFY2LjM1Mjk0SDExLjY0NzFWMTIuNzA1OUg2LjM1Mjk0VjE4SDBWMTIuNzA1OVYxMS42NDcxVjYuMzUyOTRWMFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==',
            },
          },
          {
            anchorText: '',
            anchorHref: 'https://www.instagram.com/skysport/#',
            anchorRel: 'external',
            anchorZoneIdQp: '',
            anchorTarget: '_blank',
            icon: {
              classNames: 'icon icon--social icon--instagram icon--small icon--c-light',
              svg: 'PHN2ZyB2aWV3Qm94PSIwIDAgMTggMTgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9Imljb25fX3N2ZyBpY29uX19zdmctLWluc3RhZ3JhbSIgZmlsbD0iY3VycmVudENvbG9yIiB3aWR0aD0iODAiIGhlaWdodD0iODAiIGFyaWEtbGFiZWw9Ikluc3RhZ3JhbSIgcm9sZT0iaW1nIj48cGF0aCBkPSJNMTIuNDkwMyAxOEg1LjUwOTczQzIuNDc0NzEgMTggMCAxNS41MjUzIDAgMTIuNDkwM1Y1LjUwOTczQzAgMi40NzQ3MSAyLjQ3NDcxIDAgNS41MDk3MyAwSDEyLjQ5MDNDMTUuNTI1MyAwIDE4IDIuNDc0NzEgMTggNS41MDk3M1YxMi40OTAzQzE4IDE1LjUyNTMgMTUuNTI1MyAxOCAxMi40OTAzIDE4Wk01LjUzMzA4IDEuMzU0MDlDMy4yNDUxNCAxLjM1NDA5IDEuMzc3NDMgMy4yMjE3OSAxLjM3NzQzIDUuNTA5NzNWMTIuNDkwM0MxLjM3NzQzIDE0Ljc3ODIgMy4yNDUxNCAxNi42NDU5IDUuNTMzMDggMTYuNjQ1OUgxMi40OTAzQzE0Ljc3ODIgMTYuNjQ1OSAxNi42NDU5IDE0Ljc3ODIgMTYuNjQ1OSAxMi40OTAzVjUuNTA5NzNDMTYuNjQ1OSAzLjIyMTc5IDE0Ljc3ODIgMS4zNTQwOSAxMi40OTAzIDEuMzU0MDlINS41MzMwOFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjxwYXRoIGQ9Ik05LjAxMTc2IDEzLjU0MDhDNi41MTM3IDEzLjU0MDggNC40NTkyMyAxMS41MDk3IDQuNDU5MjMgOC45ODgyNkM0LjQ1OTIzIDYuNDkwMiA2LjQ5MDM2IDQuNDM1NzMgOS4wMTE3NiA0LjQzNTczQzExLjUzMzIgNC40MzU3MyAxMy41NjQzIDYuNDY2ODYgMTMuNTY0MyA4Ljk4ODI2QzEzLjU2NDMgMTEuNTA5NyAxMS41MDk4IDEzLjU0MDggOS4wMTE3NiAxMy41NDA4Wk05LjAxMTc2IDUuODM2NTFDNy4yNjA3OCA1LjgzNjUxIDUuODM2NjYgNy4yNjA2MyA1LjgzNjY2IDkuMDExNjFDNS44MzY2NiAxMC43NjI2IDcuMjYwNzggMTIuMTg2NyA5LjAxMTc2IDEyLjE4NjdDMTAuNzYyNyAxMi4xODY3IDEyLjE4NjkgMTAuNzYyNiAxMi4xODY5IDkuMDExNjFDMTIuMTg2OSA3LjI2MDYzIDEwLjc2MjcgNS44MzY1MSA5LjAxMTc2IDUuODM2NTFaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48cGF0aCBkPSJNMTUuMjQ1MiAzLjk2ODg2QzE1LjI0NTIgNC42MjI1NiAxNC43MDgzIDUuMTU5NTIgMTQuMDU0NiA1LjE1OTUyQzEzLjQwMDkgNS4xNTk1MiAxMi44NjM5IDQuNjIyNTYgMTIuODYzOSAzLjk2ODg2QzEyLjg2MzkgMy4zMTUxNiAxMy40MDA5IDIuNzc4MiAxNC4wNTQ2IDIuNzc4MkMxNC43MDgzIDIuNzc4MiAxNS4yNDUyIDMuMjkxODIgMTUuMjQ1MiAzLjk2ODg2WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+',
            },
          },
          {
            anchorText: '',
            anchorHref: 'https://www.tiktok.com/@skysport',
            anchorRel: 'external',
            anchorZoneIdQp: '',
            anchorTarget: '_blank',
            icon: {
              classNames: 'icon icon--social icon--tiktok icon--small icon--c-light',
              svg: 'PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMTgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9Imljb25fX3N2ZyBpY29uX19zdmctLXRpa3RvayIgZmlsbD0iY3VycmVudENvbG9yIiB3aWR0aD0iODAiIGhlaWdodD0iODAiIGFyaWEtbGFiZWw9IlRpa1RvayIgcm9sZT0iaW1nIj48cGF0aCBkPSJNMTYgNC4yMDkzNUMxMy42MzI3IDQuMjA5MzUgMTEuNzE0MyAyLjMyNTE3IDExLjcxNDMgMEg4LjQ4OThWMTIuMjQ3MkM4LjQ4OTggMTMuNjcwNCA3LjMwNjEzIDE0LjgzMyA1Ljg1NzE1IDE0LjgzM0M0LjQwODE3IDE0LjgzMyAzLjIyNDQ5IDEzLjY3MDQgMy4yMjQ0OSAxMi4yNDcyQzMuMjI0NDkgMTAuODI0MSA0LjQwODE3IDkuNjYxNDcgNS44NTcxNSA5LjY2MTQ3QzYuMTIyNDUgOS42NjE0NyA2LjQyODU3IDkuNzAxNTYgNi42NzM0NyA5Ljc4MTc0VjYuNTU0NTZDNi40MDgxNyA2LjUxNDQ3IDYuMTIyNDUgNi40OTQ0MyA1Ljg1NzE1IDYuNDk0NDNDMi42MzI2NiA2LjQ5NDQzIDAgOS4wNjAxNCAwIDEyLjI0NzJDMCAxNS40MTQzIDIuNjEyMjUgMTggNS44NTcxNSAxOEM5LjA4MTY0IDE4IDExLjcxNDMgMTUuNDM0MyAxMS43MTQzIDEyLjI0NzJWNS43NzI4M0MxMi44Nzc2IDYuNzE0OTIgMTQuMzg3OCA3LjI3NjE3IDE2IDcuMjc2MTdWNC4yMDkzNVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==',
            },
          },
        ],
      },
    ],
  },
};
